export const SHARE_SHEET_CLASS_NAME =
  "bg-[#FFF9EC] px-3 pb-4 pt-3 shadow-[0_-12px_76px_rgba(0,0,0,0.16)]";

export const BOTTOM_SHEET_FALLBACK_TITLE = "Bottom sheet dialog";

// Match the page width while Radix reserves the removed scrollbar's space on the body.
export const DETAILS_SHEET_CLASS_NAME =
  "fixed left-[calc((100%-var(--removed-body-scroll-bar-size,0px))/2)] z-50 flex w-[calc(100%-var(--removed-body-scroll-bar-size,0px))] max-w-[437px] -translate-x-1/2 flex-col overflow-hidden rounded-t-[16px] border border-black bg-[#FFFAEF] shadow-[0_-12px_76px_rgba(0,0,0,0.16)] focus:outline-none";

export const DETAILS_SHEET_SCROLL_CLASS_NAME =
  "min-h-0 flex-1 overflow-y-auto overscroll-y-contain px-3 pb-3";

export const DETAILS_SHEET_SPRING = {
  type: "spring",
  stiffness: 260,
  damping: 24,
  bounce: 0.35,
} as const;

export const DETAILS_SHEET_COLLAPSED_RATIO = 0.9;
export const DETAILS_SHEET_MIN_HEIGHT_RATIO = 0.5;
export const DETAILS_SHEET_MIN_HEIGHT = 200;
export const DETAILS_SHEET_CLOSE_HEIGHT_RATIO = 0.4;
export const DETAILS_SHEET_EXPAND_DRAG_THRESHOLD = -60;
export const DETAILS_SHEET_CLOSE_DRAG_THRESHOLD = 80;
export const DETAILS_SHEET_DRAG_ELASTIC = 0.2;
